import { useAuth } from "@/modules/auth/hooks/useAuth"
import type { ReactNode } from "react";

interface InternalOnlyProps {
  children: ReactNode;
  fallback?: ReactNode;
}

export const InternalOnly: React.FC<InternalOnlyProps> = ({children, fallback}) => {
  const { isInternalUser } = useAuth()

  if (!isInternalUser) return fallback || null;

  return children;
};
